module.exports = __webpack_public_path__ + "img/67.a8dfe619.jpg";